import { createContext, useContext, useMemo, useState } from "react";
import dayjs from "dayjs";

const AnalyticsSyncDateContext = createContext(null);

export const AnalyticsSyncDateProvider = ({
    children,
    enableDateSync = true,
    setEnableDateSync = () => { },
    initialFromDate = dayjs(),
    initialToDate = dayjs(),
}) => {
    const [fromDate, setFromDate] = useState(() => initialFromDate);
    const [toDate, setToDate] = useState(() => initialToDate);

    const value = useMemo(
        () => ({
            fromDate,
            toDate,
            setFromDate,
            setToDate,
            enableDateSync,
            setEnableDateSync,
        }),
        [fromDate, toDate, enableDateSync, setEnableDateSync]
    );

    return (
        <AnalyticsSyncDateContext.Provider value={value}>
            {children}
        </AnalyticsSyncDateContext.Provider>
    );
};

export const useAnalyticsSyncDate = () => {
    const context = useContext(AnalyticsSyncDateContext);

    if (!context) {
        throw new Error(
            "useAnalyticsSyncDate must be used within AnalyticsSyncDateProvider"
        );
    }

    return context;
};
